// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"style_chartContainer__k9ZnV","scorecard":"style_scorecard__1V5K4"};